import { Badge } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

// An Owner's chip on the ok-green tint; everyone else's on a quiet fill.
const TONE = {
  owner: { bg: 'rgba(21, 128, 61, 0.10)', color: 'redesign.amount.income', _dark: { bg: 'rgba(74, 222, 128, 0.14)' } },
  other: { bg: 'redesign.bg.card', color: 'redesign.text' },
};

/**
 * A workspace role, drawn as the switcher draws it: the role's name on a quiet
 * chip, green for an Owner. The guest flow shows it beside whose space this
 * is, so every stop reads as "this is what you can do here".
 */
export default function RoleChip({ role, ...rest }) {
  const { t } = useTranslation('workspaces');
  if (!role) return null;
  return (
    <Badge
      {...TONE[role === 'Owner' ? 'owner' : 'other']}
      textTransform="none"
      fontSize="12px"
      fontWeight={600}
      px="8px"
      py="2px"
      borderRadius="6px"
      flexShrink={0}
      {...rest}
    >
      {t(`roles.${role}`, role)}
    </Badge>
  );
}
